export default __webpack_public_path__ + "static/media/GenerateJdbcUserToken.89dc196d.png";